const appTabsStorageKey = "appTabsMetadata";

export const loadAppTabsMetaData = () => {
  try {
    const serializedState = localStorage.getItem(appTabsStorageKey);
    if (serializedState === null) {
      return {};
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const storeAppTabsMetadata = (_oldMetadata, newMetaData) => {
  // no need to redact the data
  try {
    const serializesState = JSON.stringify(newMetaData);
    localStorage.setItem(appTabsStorageKey, serializesState);
  } catch (err) {
    console.error(err);
  }
};
